<template>
  <v-card
    class="pa-0"
    tile
  >
    <v-card-title
      :style="`background-color:${primaryColor}; height:40px; font-size:13px;color:white;`"
      class="ma-0 px-3 py-0"
    >
      <v-img
        class="mr-3"
        max-height="20px"
        max-width="26px"
        src="../assets/sort.png"
      />
      ソート順選択
      <v-spacer />
      <v-btn
        :class="sortType%2 ==0 ? `selected-order`:`not-selected-order`"
        icon
        tile
        @click="selectOrder(0)"
      >
        <v-img
          v-if="sortType%2 ==0"
          height="20px"
          max-height="20px"
          max-width="20px"
          src="../assets/syojun_w.png"
          width="20px"
        />
        <v-img
          v-if="sortType%2 ==1"
          height="20px"
          max-height="20px"
          max-width="20px"
          src="../assets/syojun_g.png"
          width="20px"
        />
      </v-btn>
      <v-btn
        :class="sortType%2 ==1 ? `selected-order mr-3`:`not-selected-order mr-3`"
        icon
        tile
        @click="selectOrder(1)"
      >
        <v-img
          v-if="sortType%2 ==1"
          height="20px"
          max-height="20px"
          max-width="20px"
          src="../assets/kojun_w.png"
          width="20px"
        />
        <v-img
          v-if="sortType%2 ==0"
          height="20px"
          max-height="30px"
          max-width="30px"
          src="../assets/kojun_g.png"
          width="20px"
        />
      </v-btn>
    </v-card-title>
    <v-list class="ma-0 pa-0">
      <v-list-item
        v-for="(item,index) in visibleItems"
        :key="index"
        :class="(index%2==0 ? `list-item-white`:`list-item-grey`)+` pa-0 px-2 ma-0`"
        dense
        @click="selectSort(index)"
      >
        <ListIcon
          :style="`color: ${accentColor};width:6px;height:7px`"
          class="mr-2"
        />
        {{ item.name }}
        <v-spacer />
        <v-icon
          v-if="index==Math.floor(sortType/2)"
          class="pa-2"
          color="secondary"
        >
          mdi-check-bold
        </v-icon>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import ListIcon from "@/component/svg/ListIcon";

export default {
  name: "SortTypeSelect",
  components: {
    ListIcon
  },
  props: ["sortType", "items", "callback"],
  data() {
    return {
      accentColor: null,
      primaryColor: null,
      backgroundColor: null,
      visibleItems: this.items.filter(function (element, index) {
        return index % 2 == 0;
      })
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.primaryColor = this.$vuetify.theme.themes.light.primary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
  },
  methods: {
    selectOrder(type) {
      if(this.items[this.sortType].name=="手動並び替え"){
        this.callback(14)
      }else{
        if (this.sortType % 2 == 0) {
          if (type == 0) {

          } else{
            this.callback(this.sortType + 1)
          }
        } else {
          if (type == 0) {
            this.callback(this.sortType - 1)
          } else {

          }
        }
      }

    },
    selectSort(index) {
      let sortType = this.sortType % 2
      if(this.items[index*2+sortType].name=="手動並び替え"){
        this.callback(14)
      }else{
        this.callback(index * 2 + sortType)
      }

    }
  }
}
</script>

<style scoped>
.selected-order {
  border: solid 2px var(--v-bordercolor-base);
  background-color: var(--v-secondary-base);
  width: 30px;
  height: 30px;
  padding: 3px;
}

.not-selected-order {
  border: solid 2px var(--v-bordercolor-base);
  background-color: white;
  width: 30px;
  height: 30px;
  padding: 3px;
}

.list-item-white {
  background-color: var(--v-background2-base);
  font-size: 12px;
  height: 36px;
  border: solid 2px var(--v-background2-base);
}

.list-item-grey {
  background-color: var(--v-background-base);
  font-size: 12px;
  height: 36px;
  border: solid 2px var(--v-bordercolor-base);
}
</style>